<template>
  <div>
    <v-card outlined class="pa-6 mx-4 my-6 elevation-0">
      <div class="d-flex align-center justify-space-between">
        <v-autocomplete
          no-data-text="Danh sách trống"
          label="Đầu điểm"
          item-text="title"
          :items="factorList"
          item-value="id"
          clearable
          outlined
          v-model="factorData"
          return-object
          hide-details
          dense
          class="mr-6"
          v-on:input="$emit('input', $event)"
        ></v-autocomplete>
        <v-btn outlined color="#0D47A1" :disabled="!factorData || !factorData.id" @click="search">Chọn Nhập</v-btn>
      </div>
    </v-card>

    <div v-if="markStudents && markStudents.length">
      <div class="full-width text-end">
        <v-menu open-on-hover bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-4 mb-4" color="green" dark v-bind="attrs" v-on="on" outlined>
              Nhập/xuất Excel
            </v-btn>
          </template>

          <v-list>
            <v-list-item class="cursor-pointer" @click="showExcelDialog = !showExcelDialog">
              <v-list-item-title>Tải lên tệp Excel chứa điểm</v-list-item-title>
            </v-list-item>
            <v-list-item class="cursor-pointer" @click="exportExcelTemplate">
              <v-list-item-title>Tải xuống tệp Excel mẫu</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-btn
          class="mr-4 mb-4"
          v-if="$vuetify.breakpoint.mdAndUp"
          depressed
          dark
          color="green"
          outlined
          @click="showExcelDialog = !showExcelDialog"
        >
          <v-icon left>mdi-file-excel</v-icon> Thêm điểm theo tệp excel
        </v-btn> -->
      </div>

      <div class="d-flex mx-4">
        <div v-if="slot.subject" class="text-h6 text-uppercase" style="color: #0d47a1">
          Môn {{ slot | _get('subject.title') }} - Lớp {{ slot | _get('class.title') }} -
          {{ factorData.title }}
        </div>
        <v-spacer />
        <v-btn @click="saveMarks" color="primary">Lưu</v-btn>
      </div>

      <div class="d-flex table-container pt-4">
        <v-form ref="form">
          <table class="mark-table">
            <thead>
              <tr>
                <th>STT</th>
                <th>Học sinh</th>
                <th>Ngày sinh</th>
                <th v-if="hasGroup">Nhóm</th>
                <th :colspan="100">Điểm</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, studentIndex) in studentGroupMarks"
                :key="item.student.id"
                :class="item.groupCount % 2 === 0 ? '' : 'group'"
              >
                <td>{{ studentIndex + 1 }}</td>
                <td class="px-2 py-0" style="text-align: left">
                  <CardStudentName :student="item.student" link />
                </td>
                <td>{{ item.student.dob | ddmmyyyy }}</td>
                <td v-if="hasGroup" class="font-weight-bold">{{ item.group }}</td>
                <div v-if="slot.subject.markType === 'mark'">
                  <td v-for="(mark, markIndex) in item.marks" :key="markIndex" class="mark-text-field ma-0 px-2">
                    <v-text-field
                      v-if="mark.markInDate"
                      class="mark-text-field"
                      v-model="mark.value"
                      hide-details
                      outlined
                      dense
                      type="number"
                      :rules="[$rules.markInput]"
                      :ref="`input-${studentIndex}-${markIndex}`"
                      @keydown.tab.prevent="tab(`input-${studentIndex + 1}-${markIndex}`)"
                    />
                    <v-tooltip bottom v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="mark-text-field">
                          <!-- @click="markInOtherDateClicked(item.student, mark)" -->
                          <span v-bind="attrs" v-on="on" style="font-size: 16px;cursor: pointer;">
                            {{ mark.value }}
                          </span>
                        </div>
                      </template>
                      <span>{{ mark.date | ddmmyyyy }}</span>
                    </v-tooltip>
                  </td>
                </div>

                <div v-else>
                  <td v-for="(mark, order) in item.marks" :key="order" class="evaluate-text-field ma-0 px-2">
                    <v-select
                      v-if="mark.markInDate"
                      :items="[
                        { text: 'Đạt', value: 1 },
                        { text: 'Chưa Đạt', value: 0 }
                      ]"
                      v-model="mark.value"
                      outlined
                      dense
                      hide-details
                      class="evaluate-text-field ma-0 px-2"
                    ></v-select>
                    <v-tooltip bottom v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="evaluate-text-field">
                          <!-- @click="markInOtherDateClicked(item.student, mark)" -->
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="mx-4"
                            style="font-size: 16px; white-space: nowrap;cursor: pointer;"
                          >
                            {{ mark.value | getEvaluate }}
                          </span>
                        </div>
                      </template>
                      <span>{{ mark.date | ddmmyyyy }}</span>
                    </v-tooltip>
                  </td>
                </div>
              </tr>
            </tbody>
          </table>
        </v-form>
      </div>

      <div class="d-flex justify-end ma-4">
        <v-btn color="primary" @click="saveMarks">Lưu</v-btn>
      </div>
    </div>
    <MarkBlankView v-else :markView="false" />

    <MarkInputExcelDialog :filterParams="searchParams" :state="showExcelDialog" @done="markExcelImported" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { get, chunk, orderBy, groupBy, flatten } from 'lodash'
import MarkBlankView from '@/modules/mark/MarkBlankView.vue'
import { Factor } from '@/plugins/api'
import moment from 'moment'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { saveAs } from 'file-saver'
import Excel from 'exceljs'
import LoadAsset from 'load-asset'
import { Class } from '../../../plugins/api'

export default {
  data() {
    return {
      factorData: {},
      factors: [],
      semester: {},
      markStudents: [],
      searchParams: {},
      studentGroupMarks: [],
      hasGroup: true,
      showExcelDialog: false
    }
  },
  components: {
    MarkBlankView,
    CardStudentName,
    MarkInputExcelDialog: () => import('@/modules/mark/MarkInputExcelDialog.vue')
  },
  computed: {
    ...mapState('ClassNoteDetail', ['slot', 'date', 'currentSchoolYear']),
    ...mapGetters('ClassMarkInput', ['studentMarks']),
    ...mapGetters('auth', ['profile']),
    ...mapGetters('ClassNoteDetail', ['classNoteDetailData']),

    filterFactor() {
      return {
        subject: get(this.slot, 'subject.id')
      }
    },
    factorList() {
      return this.factors.map(c => ({ ...c, title: `${c.title}` }))
    }
  },
  created() {
    this.fetchFactor()
  },
  methods: {
    ...mapActions('ClassMarkInput', ['fetchMarks', 'createMark', 'updateMark', 'removeMark']),
    ...mapActions('ClassNoteDetail', ['mappingMark']),

    async fetchFactor() {
      const semesters = this.currentSchoolYear.semesters
      const semester = semesters.find(semester =>
        moment(this.date).isBetween(moment(semester.startDate), moment(semester.endDate))
      )
      if (semester && semester.id) {
        this.factors = await Factor.fetch({
          subject: get(this.slot, 'subject.id'),
          semesterType: semester.type,
          _sort: 'index:ASC'
        })
        this.semester = semester
      } else {
        this.$alert.error('Ngày không thuộc học kỳ')
      }
    },
    async search() {
      this.$loading.active = true

      this.searchParams = {
        class: this.slot.class,
        date: this.date,
        factor: this.factorData,
        subject: this.slot.subject,
        semester: this.semester
      }
      await this.fetchMarks(this.searchParams)
      this.markStudents = this.studentMarks
      const groupCountObj = {}
      let studentGroupMarks = [...this.studentMarks].map(sm => {
        const group = get(this.slot, `class.details[${sm.student.id}]`, 0)
        groupCountObj[`${group}`] = (groupCountObj[`${group}`] || 0) + 1
        const obj = {
          ...sm,
          group
        }
        return obj
      })

      // count group to display group in other background
      let count = 0
      let studentGroupMarkObj = groupBy(studentGroupMarks, 'group')
      // remove Group column if class has not group
      const keys = Object.keys(studentGroupMarkObj)
      if (keys.length === 1 && (keys[0] === 'null' || keys[0] === '0')) this.hasGroup = false

      for (const group of Object.keys(studentGroupMarkObj)) {
        let smList = studentGroupMarkObj[group]
        smList = smList.map(sm => {
          const obj = {
            ...sm,
            groupCount: count
          }
          return obj
        })
        count++
        studentGroupMarkObj[group] = smList
      }
      studentGroupMarks = flatten(Object.values(studentGroupMarkObj))

      studentGroupMarks = orderBy(studentGroupMarks, ['group', 'student.nameToNumber'], ['asc'])
      this.studentGroupMarks = studentGroupMarks
      this.$loading.active = false
    },
    async saveMarks() {
      if (!this.$refs.form.validate()) {
        this.$alert.error('Điểm phải trong khoảng từ 0 đến 10')
        return
      }
      const groups = chunk(this.markStudents, 3)
      this.$loading.active = true
      try {
        let markIds = []
        for (let subMarkStudents of groups) {
          const promises = subMarkStudents.reduce((acc, cur) => {
            const markPromies = cur.marks.map(({ id, value, rawValue }) => {
              if (id) {
                if (rawValue !== value) {
                  if (value) {
                    return this.updateMark({ id, value })
                  } else {
                    return this.removeMark(id)
                  }
                } else Promise.resolve()
              } else {
                if (parseFloat(value) >= 0) {
                  return this.createMark({
                    student: cur.student.id,
                    value: value,
                    class: get(this.slot, 'class.id'),
                    subject: get(this.slot, 'subject'),
                    grade: get(this.slot, 'class.grade'),
                    semester: this.semester.id,
                    factor: this.factorData.id,
                    date: this.date,
                    staff: this.profile.id,
                    teacher: this.profile.id
                  })
                } else {
                  Promise.resolve()
                }
              }
            })
            return [...acc, ...markPromies]
          }, [])

          const marks = await Promise.all(promises)
          const subMarkIds = marks.filter(m => m && m.id).map(m => m.id)
          markIds = [...markIds, ...subMarkIds]
        }

        await this.mappingMark({
          markIds,
          classNoteDetailData: { ...this.classNoteDetailData }
        })
        await this.search(this.searchParams)
        this.$alert.success('Lưu điểm thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Đã có lỗi xảy ra ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    async markExcelImported(markIds) {
      await this.mappingMark({
        markIds,
        classNoteDetailData: { ...this.classNoteDetailData }
      })
      await this.search()
    },
    tab(ref) {
      // tab theo chieu doc
      this.$refs[ref] && this.$refs[ref][0].focus()
    },

    async exportExcelTemplate() {
      this.$loading.active = true
      try {
        const workbook = new Excel.Workbook()
        const buffer = await LoadAsset({ url: '/mark-template.xlsx', type: 'binary' })
        await workbook.xlsx.load(buffer)
        const worksheet = workbook.worksheets[0]

        const classData = await Class.fetchOne(this.searchParams.class.id)
        let students = classData.students.filter(s => s.status === 'active')
        students = orderBy(students, ['nameToNumber'], ['asc'])
        const filters = this.$options.filters

        students.map((student, index) => {
          const rowIndex = index + 2
          worksheet.getCell(`A${rowIndex}`).value = student.name
          worksheet.getCell(`B${rowIndex}`).value = filters.getStudentCode(student.code)
          worksheet.getCell(`C${rowIndex}`).value = filters.ddmmyyyy(student.dob)
          worksheet.getCell(`D${rowIndex}`).value = this.searchParams.class.title
          worksheet.getCell(`E${rowIndex}`).value = filters.factorType(this.searchParams.factor.type)
        })

        const excelBuffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        saveAs(
          blob,
          `${this.searchParams.class.title}-DanhSachHS-Diem${this.$options.filters.factorType(
            this.searchParams.factor.type
          )}.xlsx`
        )
      } catch (error) {
        console.error(error)
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mark-text-field {
  width: 100px;
  // margin: 4px;
}
.evaluate-text-field {
  width: 150px;
  // margin: 4px;
}

.mark-table {
  td,
  tr,
  th {
    border: 1px solid #e0e0e0;
  }
  td,
  th {
    padding: 14px 20px;
    text-align: center;
  }
  color: #212121;
  border-collapse: collapse;
  width: 100%;
}
.table-container {
  overflow: auto;
  max-width: 100%;
}
.group {
  background: rgb(234, 234, 234);
}
</style>
